import React from 'react';
import { SponsorSidebar } from '../SponsorAd';
import { SidebarAdStack } from '../AdSystem';
import MemberAdsSidebar from '../MemberAdsSidebar';
import { HighlightsRail } from './HighlightsRail';

export function FeedSidebar({ user, showAds }) {
  // We always render the highlights rail — even for ad-free users —
  // because it's editorial content, not advertising. Ad-free should
  // mean "no ads", not "no community curation surface".
  return (
    <div className="hidden lg:block">
      <div className="sticky top-24 space-y-6">
        <HighlightsRail limit={6} />
        {showAds && (
          <>
            <MemberAdsSidebar limit={4} title="Featured Members" />
            <SponsorSidebar interests={user?.interests || []} page="feed" />
            <SidebarAdStack maxAds={3} />
          </>
        )}
      </div>
    </div>
  );
}

export default FeedSidebar;
